import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";
import { Colors } from "~/config/Colors";

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .padding-form {
    padding: 0 1em 1em 1em;
  }

  .row {
    margin-bottom: 0.5em;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .back{
    display: flex;
    justify-content: center;
    margin-top: 2em;  

    .back-color{
      background: #FCFCFC;
      border-radius: 1em;
      height: 20em;
      width: 98%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .content{
        height: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 2em;

        .back-info{
          background: white;
          padding: 1.5em 1.5em 1em 1em;
          border-radius: 1em;
          height: 20em;
          width: 40em;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          box-shadow: 0px 0px 20px rgb(0 0 0 / 3%);
          
          .card-top-info {
            display: flex;

            .card-top {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
              margin-bottom: 3em;
        
              .card-top-left {
                display: flex;
                margin-left: 1em;
                flex-direction: column;
                
                .cod {
                  font-size: 0.75em;
                  width: 100%;
                  font-weight: 800;
                  color: #B1B1B1;
                  margin-right: 0.75em;
                }

                .titulo {
                  font-size: 0.75em;
                  width: 100%;
                  color: #868585;
                  margin-right: 0.75em;

                  .bold {
                    font-weight: 700;
                  }

                  .bold-segundo {
                    font-weight: 700;
                    margin-left: 1em;
                  }
                }

                .cnpj {
                  font-size: 0.75em;
                  width: 100%;
                  color: #868585;
                  margin-right: 0.75em;

                  .bold {
                    font-weight: 700;
                  }
                }
              }

              .card-info {
                margin-left: 1em;
                margin-top: 1em;
              }

              .sub-titulo {
                font-size: 0.75em;
                width: 100%;
                color: #868585;
                margin-right: 0.75em;
                
                .bold {
                  font-weight: 700;
                }
              }

              .rsp {
                font-size: 0.75em;
                width: 100%;
                color: #868585;
                margin-right: 0.75em;

                .bold {
                  font-weight: 700;
                }
              }
        
              .card-top-right {
                display: flex;
                margin-right: 1em;
                margin-top: 1em;
                flex-direction: column;
        
                .cod {
                  font-size: 0.85em;
                  width: 100%;
                  font-weight: 800;
                  color: ${Colors.Color4};
                  margin-right: 0.75em;
                }
              }
            }
          }

          .point {
            height: 4em;
            width: 6em;
            border-radius: 0.6em;
            margin-left: 5em;
            border: dashed white 0.125em;
            display: flex;
            background: white;
            align-items: flex-start;
  
            .logo{
              display: flex;
              align-items: center;
              justify-content: center;
  
              .logo_img {
                width: 100%;
  
              }
            }
          } 
        }

        .acord {
          border-radius: 1em;
          height: 15em;
          width: 10em;
        }
      }
    }
  }
`;